var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "default-banner private-genre-banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-genre-img.png"
    }
  })], 1), _vm._m(0), _c('v-divider', {
    staticClass: "primary"
  })], 1)]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/private/private-genre-img2.png"
    }
  })], 1), _vm._m(1), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _vm._m(2)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("근현대미술")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Emerging Artist")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-arrow-left mr-6"
  }), _c('span', [_vm._v("PREV")])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-next"
  }, [_c('span', [_vm._v("NEXT")]), _c('i', {
    staticClass: "icon icon-arrow-right ml-6"
  })])]);
}]

export { render, staticRenderFns }